exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".car-info,\n.comment-section {\n  padding: 10px;\n}\n\n.car-info {\n  width: 75%;\n  float: left;\n}\n\n.comment-section {\n  width: 25%;\n  float: right;\n}\n\n.image {\n  display: block;\n  width: 100%;\n}\n\n.comments-title {\n  margin-bottom: 0;\n}\n\n.comments {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.comment {\n  border-bottom: 1px dotted #ddd;\n  padding: 10px;\n}\n\n.comment:last-child {\n  border-bottom: 0;\n}\n\n.comment .body {\n  margin: 0 0 5px;\n  font-family: Georgia, serif;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/baylorrae/code/tutorials/graphcool/garage/src/app/car-detail/car-detail.component.css
// module id = ../../../../../src/app/car-detail/car-detail.component.css
// module chunks = main